import React, { useEffect, useRef, useState } from 'react';
import './styles.css';

import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import Image from 'react-bootstrap/Image';

import VideoComponent from './VideoComponent';
import { useTranslate } from '@tolgee/react';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';
import { useSelector, useDispatch } from 'react-redux';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { COMPACT_MODE_HEIGHT } from '../contants';
import PreviewImagesSkeleton from '../loaders/previewImagesSkeleton';
import OnImagesLoaded from '../../../onImagesLoaded';
import PlatformIconSkeleton from '../loaders/platformIconSkeleton';
import { GOOGLE } from '../../../../config/constants';
import ImportedPostsMediaPreview from './importedPostsMediaPreview';
import AltTagButton from './buttons/altTagsBtn';

export default function GooglePostPreview({
  platform = GOOGLE,
  cropList = null,
  mediaFiles = null,
  postText = null,
  profileName = null,
  platformIcon = null,
  previewAssets,
  viewAssets
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    created_in_lomavis,
    ui: { previewMode }
  } = useSelector((state: any) => state.lomavisCreator);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <div className="w-100 m-2">
      <Card className="w-100">
        <div className="d-flex justify-content-between p-2 px-3">
          <div className="d-flex flex-row align-items-center">
            <div className="w-50px h-50px">
              <OnImagesLoaded
                onLoaded={() => {}}
                placeholder={<PlatformIconSkeleton />}
              >
                <Image
                  src={platformIcon}
                  className="img-fluid w-100 h-100"
                  roundedCircle
                />
              </OnImagesLoaded>
            </div>
            <div className="d-flex flex-column align-items-start ms-2">
              <span className="fw-bold">{profileName}</span>
              <small className="text-black-50">
                {t('lomavisCreator.previewCards.just_now')}
              </small>
            </div>
          </div>
        </div>

        {/* video/mp4 for both mp4 and mov video types */}

        {mediaFiles && mediaFiles.length > 0 && (
          <div
            className="asset_wrapper w-100 overflow-hidden"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <OnImagesLoaded
              onLoaded={() => {
                setIsImageLoaded(true);
              }}
              placeholder={<PreviewImagesSkeleton />}
            >
              {isImageLoaded && created_in_lomavis && (
                <div
                  style={{ zIndex: 3 }}
                  className="d-flex gap-2 justify-content-center align-items-center position-absolute ms-auto me-3 mt-3 end-0"
                >
                  <div
                    className="viewButton btn btn-sm btn-bg-white border border-dark px-3"
                    style={{
                      zIndex: 3
                    }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => viewAssets()}
                  >
                    <i
                      style={{ padding: '0px' }}
                      className="fa-regular fa-eye text-dark"
                    ></i>
                  </div>

                  <AltTagButton platform={platform} />

                  <div
                    className="btn btn-sm btn-bg-white border border-dark cropEditBtn firstImageCropEditBtn"
                    style={{ zIndex: 3 }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => previewAssets()}
                  >
                    <span className="loading-indicator spinner-border spinner-border-sm d-none"></span>
                    <span>{t('lomavisCreator.preview.edit')}</span>
                  </div>
                </div>
              )}

              <div className="w-100 d-flex justify-content-center">
                {mediaFiles &&
                  created_in_lomavis &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type == 'video' && (
                    <div className="position-relative">
                      <VideoComponent
                        posterUrl={mediaFiles[0]?.custom_thumbnail_url}
                        videoUrl={
                          mediaFiles?.[0]?.file || mediaFiles?.[0]?.video_url
                        }
                        styles={{
                          maxHeight:
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : '100%'
                        }}
                      />
                    </div>
                  )}

                {mediaFiles &&
                  created_in_lomavis &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type == 'image' && (
                    <div className="position-relative">
                      <Image
                        className="img-fluid"
                        style={{
                          objectFit: 'contain',
                          maxHeight:
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : '100%'
                        }}
                        src={mediaFiles[0].image_url}
                      />
                    </div>
                  )}
                {mediaFiles && !created_in_lomavis && (
                  <div className="position-relative">
                    <ImportedPostsMediaPreview
                      platform={platform}
                      mediaFiles={mediaFiles}
                    />
                  </div>
                )}
              </div>
            </OnImagesLoaded>
          </div>
        )}

        <div className="px-2 previewCardText d-flex align-items-start pt-2">
          <p className="py-2">
            {postText && (
              <span
                className="preview-text"
                style={{
                  color: 'black',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word'
                }}
                dangerouslySetInnerHTML={{ __html: postText }}
              />
            )}
          </p>
        </div>

        <div className="d-flex flex-row justify-content-end px-2 py-2">
          <FontAwesomeIcon className="fs-3" icon={faShareAlt} />
        </div>
      </Card>
    </div>
  );
}
